// app/products/new/page.tsx
import AppShell from "@/components/layout/AppShell";
import ProductForm from "@/components/products/ProductForm";
import PageHeader from "@/components/ui/PageHeader";

export default function NewProductPage() {
    return (
        <AppShell>
            <PageHeader
                title="New Product"
                description="Create a product and its first variant."
            />
            <ProductForm />
        </AppShell>
    );
}